import { language_tr } from "app/components/appFrame/includes/language/locales/tr_TR";
import { theme_tr } from "app/components/appFrame/includes/theme/locales/tr_TR";

export const app_tr = {
  language: language_tr,
  theme: theme_tr
};
